<template>
    <section class="message">
        <div class="modal p-4">
            <h3>Rejestracja na szkolenie {{ removeHtml(info.name) }} {{ info.trainingDate | date }}</h3>
            <p v-if="$store.getters.getRegistrationSuccess">   
                Rejestracja przebiegła pomyślnie. Dziękujemy i zapraszamy do udziału.
            </p>
            <p v-else>
                Niestety, rejestracja nie została wykonana prawidłowo. Prosimy o kontakt w celu wyjaśnienia problemu.
            </p>
            <br>
            <button 
                type="button" 
                class="btn btn-primary"
                @click="$store.commit('setDisplayRegistrationModal', false)">
                Powrót do Mój FX
            </button>
        </div>
        <div class="backdrop"></div>
    </section>
</template>

<script>
    import { stringFunctions } from '@/mixins/string-functions'

    export default {
        props: {
            info: {
                type: Object,
                required: true
            }
        },
        mixins: [
            stringFunctions
        ]
    }
</script>